import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import PageLoader from 'pageLoader.js';



/*
  TBD

  Small/medium/large should be combined into one

        small: {
        min: 0,
        max: 459
      },
      medium: {
        min: 460,
        max: 767
      },
      large: {
        min: 768,
        max: 1000000
      }
*/

export const store = new Vuex.Store({
  state: {
    getStartedMenuOpen: false,
    mobileMenuOpen: false,
    currentSection: 0,
    sections: [],
    fetchingData: false,
    isMobile: false,
    firstLoad: true,
    // isPortrait: false,
    // backDrop: false,
    language: {
      code: 'EN',
      text: 'English'
    },
    availableLanguages: [
      {
        code: 'EN',
        text: 'English'
      }, 
      {
        code: 'SV', 
        text: 'Svenska'
      }
    ], 
    screenSize: 'large',
    screenSizes: {
      large: {
        min: 0,
        max: 1000000
      }
    },
    // {
    //   path: '/',
    //   text: 'Home'
    // },
    mobileLinks: {
      EN: {
        highlight: [
          {
            path: '/service',
            text: 'The Spotin service'
          },
          {
            path: '/sellers',
            text: 'Spotin for sellers'
          },
          {
            path: '/publishers',
            text: 'Spotin for publishers'
          },
          {
            path: '/shop',
            text: 'Solutions',
            subheadings: [
              {
                path: '/incontent',
                text: 'In-content commerce'
              },
              {            
                path: '/shop',
                text: 'Virtual marketplace'
              },
              {             
                path: '/checkout',
                text: 'Checkout'
              },
            ]
          },
          // {
          //   path: '/tools',
          //   text: 'Tools',
          //   subheadings: [
          //     {
          //       path: '/commercemanager',
          //       text: 'Commerce Manager'
          //     },
          //     {            
          //       path: '/portal',
          //       text: 'Spotin Portal'
          //     },
          //   ]
          // },
        ],
        other: [
          {
            path: '/contentcommerce',
            text: 'What is content commerce?'
          },
          {
            path: '/news',
            text: 'News'
          },
          {
            path: '/press',
            text: 'Press'
          },
          {
            path: '/about',
            text: 'About us'
          },
          {
            path: '/career',
            text: 'Career'
          },
          {
            path: '/contact',
            text: 'Contact'
          }
        ]
      },
      // SV: [
      //   // {
      //   //   path: '/',
      //   //   text: 'Hem'
      //   // },
      //   {
      //     path: '/service',
      //     text: 'The Spotin service'
      //   },
      //   {
      //     path: '/sellers',
      //     text: 'Spotin for sellers'
      //   },
      //   {
      //     path: '/publishers',
      //     text: 'Spotin for publishers'
      //   },
      //   {
      //     path: '/career',
      //     text: 'Career'
      //   },
      //   {
      //     path: '/contentcommerce',
      //     text: 'What is content commerce?'
      //   },
      //   {
      //     path: '/news',
      //     text: 'News'
      //   },
      //   {
      //     path: '/press',
      //     text: 'Press'
      //   },
      //   {
      //     path: '/about',
      //     text: 'About us'
      //   },
      //   {
      //     path: '/contact',
      //     text: 'Contact'
      //   }
      // ],
    }
  },
  getters: {
    isFetchingData(state) {
      return state.fetchingData;
    },
    mobileLinks(state) {
      return state.mobileLinks[state.language.code];
    },
    getStartedMenuOpen(state) {
      return state.getStartedMenuOpen;
    },
    mobileMenuOpen(state) {
      return state.mobileMenuOpen;
    },
    currentSection(state) {
      return parseInt(state.currentSection);
    },
    hasLoaded() {
      return !this.firstLoad;
    },
    sections(state) {
      return state.sections;
    },
    // isPortrait(state) {
    //   return state.isPortrait;
    // },
    // screenSize(state) {
    //   return state.screenSize;
    // },
    isLarge(state) {
      return state.screenSize === 'large';
    },
    isMobile(state) {
      return state.isMobile;
    },
    // isMedium(state) {
    //   return state.screenSize === 'medium';
    // },
    // isSmall(state) {
    //   return state.screenSize === 'small';
    // },
    // backDrop(state) {
    //   return state.backDrop;
    // },
    language(state) {
      return state.language;
    },
    availableLanguages(state) {
      return state.availableLanguages;
    },
  },
  mutations: {
    fetchingData(state) {
      state.fetchingData = true;
    },
    dataFetched(state) {
      state.fetchingData = false;
    },
    closeMobileMenu(state) {
      state.mobileMenuOpen = false;
    },
    openGetStartedMenu(state) {
      state.getStartedMenuOpen = true;
    },
    closeGetStartedMenu(state) {
      state.getStartedMenuOpen = false;
    },
    toggleGetStartedMenu(state) {
      state.getStartedMenuOpen = !state.getStartedMenuOpen;
    },
    openMobileMenu(state) {
      state.mobileMenuOpen = true;
    },
    closeMobileMenu(state) {
      state.mobileMenuOpen = false;
    },
    toggleMobileMenu(state) {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },
    setIsMobile(state, isMobileWidth) {
      state.isMobile = isMobileWidth;
    },
    setCurrentSection(state, index) {
      index = parseInt(index);
      if(index < 0 || index > state.sections.length-1) return;
      state.currentSection = index;
      if(state.firstLoad === true) {
        state.firstLoad = false;
        if (typeof spotinAPI !== 'undefined') {
          spotinAPI.pageChanged();
        }
      }
    },
    nextSection(state) {
      const nextIndex = state.currentSection + 1;
      if(nextIndex > state.sections.length-1) return;
      state.currentSection = nextIndex;
    },
    prevSection(state) {
      const prevIndex = state.currentSection - 1;
      if(prevIndex < 0) return;
      state.currentSection = prevIndex;
    },
    setSections(state, sections) {
      state.sections = sections;
    },
    // setIsPortrait(state, isPortrait) {
    //   state.isPortrait = isPortrait;
    // },
    // setScreenSize(state, screenSize) {
    //   state.screenSize = screenSize;
    // },
    // setBackDrop(state, value) {
    //   state.backDrop = value;
    // },
    setLanguage(state, value) {
      state.language = value;
    },
  },
  actions: {
    fetchData({commit, state}, payload) {
      const currentPage = payload.currentPage;
      const inviteToken = payload.inviteToken;

      commit('fetchingData');

      PageLoader(state.language, currentPage, inviteToken, state.screenSize).then(sections => {
        commit('setSections', sections);
        commit('dataFetched');
        payload.done();
      });
    },
    observeScreenSize({commit, state}) {
      const calculateScreenSize = (event) => {
        const currentTarget = event.currentTarget;
        const width = currentTarget.innerWidth;
        commit('setIsMobile', (width <= 440));
      };

      // const getScreenSize = (width) => {
      //   return Object.keys(state.screenSizes).find((prop) => {
      //     const screenSize = state.screenSizes[prop];
      //     return screenSize.max >= width && screenSize.min <= width;
      //   });
      // };

      calculateScreenSize({currentTarget: window});
      window.addEventListener('resize', calculateScreenSize);
      window.addEventListener('orientationonchange', calculateScreenSize);
    },
    // observeIfPortrait({commit, state}) {
    //   let resizeHandler;

    //   const updateIsPortrait = (time) => {
    //     clearTimeout(resizeHandler);
    //     resizeHandler = setTimeout(()=>{
    //       const W = 1024;
    //       const H = 1200;
    //       const wW = window.innerWidth;
    //       const wH = window.innerHeight;
    //       commit('setIsPortrait', (wW/wH) < (W/H));
    //     },time);
    //   };

    //   updateIsPortrait(0);
    //   window.addEventListener('resize', ()=>updateIsPortrait(0));
    //   window.addEventListener('orientationonchange', ()=>updateIsPortrait(300));
    // }
  }
});



// WEBPACK FOOTER //
// ./store.js